<h1>{{ text | translate | uppercase }}</h1>
